// import WrapSaveDiaModal from './wrap-login-modal/index.jsx';
import CustomModalComponent from '../../components/modal/custom-modal';
import './index.css';
import React from 'react';
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';
// import Button from '../button/button.jsx';
import { Button } from "@chakra-ui/button";
import modalHeadBack from '../../lib/assets/modalWifi.png'
import {
    injectIntl,
    defineMessages,
    FormattedMessage
} from 'react-intl';


class SaveWorkModal extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
        };
        bindAll(this, [
        ]);
    }

    componentDidMount () {
    }

    render () {
        const {
        } = this.state;
        return (
            <CustomModalComponent
                className="modalContentWork"
                id="saveWorkModal"
                contentLabel='提示'
                hasHeaderLine={false}
                headerImageTop={modalHeadBack}
                onRequestClose={this.props.onCloseModal}
                showCloseBtn={true}
            >
                <div className="saveMessage">
                    是否保存当前程序？
                </div>
                <div className="saveWorkBtn">
                    <Button className="saveBtn" onClick={this.props.onGetOkClick}>
                        {/* 确定 */}
                        保存
                    </Button>
                    <Button className="closeBtn" onClick={this.props.onCancelModal}>
                        放弃
                    </Button>
                </div>
                 
            </CustomModalComponent>
        );
    }
}

SaveWorkModal.propTypes = {
    onGetOkClick: PropTypes.func,
    onCloseModal: PropTypes.func,
    onCancelModal: PropTypes.func
};

const mapStateToProps = (state, ownProps) => ({
});

const mapDispatchToProps = dispatch => ({
});

export default SaveWorkModal